/**
 * Created by admin on 2018/8/3.
 */
import * as accountService from '../services/account';
import { REPORT_ACTIVE_TYPE } from '../utils/constants';

export default {
  namespace: 'roomDevice',
  state: {
    roomId: '',
    roomName: '',
    deviceList: []
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *getRoomDevices({ resolve, reject }, { call, put, select }) {
      const { roomId } = yield select(state => state.roomDevice);
      const { data: deviceList = [], status, msg } = yield call(
        accountService.getRoomDevices,
        roomId
      );
      if (status === 0) {
        yield put({ type: 'update', payload: { deviceList } });
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    },
    *updateRoomDeviceState(
      { brokenDevIds, resolve, reject },
      { call, select }
    ) {
      const { roomId, roomName } = yield select(state => state.roomDevice);
      const { status, msg } = yield call(accountService.updateRoomDeviceState, {
        roomId,
        brokenDevIds
      });
      const { userId: optId } = yield select(state => state.login.userInfo);
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.EDIT_DEVICE_STATE,
        optResult: status,
        actContent: `维护会议室[${roomName}]设备状态操作成功`
      };
      if (status === 0) {
        resolve && resolve();
      } else {
        params.actContent = `维护会议室[${roomName}]设备状态操作失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(accountService.recordActivityLog, params);
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/roomDevice.js